import { CaretRightIcon } from '@phosphor-icons/react';

import { cn } from '@shared/lib/utils';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@shared/ui/card';

export type PracticeCardAction = 'full' | 'custom' | 'targeted';

export interface PracticeCardProps {
  title: string;
  description: string;
  icon: JSX.Element;
  onClick?: () => void;
}

export interface PracticeCardData extends Omit<PracticeCardProps, 'onClick'> {
  action: PracticeCardAction;
}

export const PracticeCard = ({ title, description, icon, onClick }: PracticeCardProps) => {
  const content = (
    <Card
      size="sm"
      className={cn(
        'cursor-pointer flex-row items-center gap-0 rounded-xl px-5 py-3!',
        `
          transition-shadow duration-200 ease-out
          hover:shadow-md
        `
      )}
    >
      <CardContent className="flex min-w-0 flex-1 items-center gap-1 p-0!">
        <div className="flex size-6 shrink-0 items-center justify-center">{icon}</div>
        <CardHeader className="min-w-0 grow gap-1 pe-0!">
          <CardTitle className="text-sm/4.5 font-medium text-foreground">{title}</CardTitle>
          <CardDescription className="text-xs/4">{description}</CardDescription>
        </CardHeader>
      </CardContent>

      <CaretRightIcon
        weight="bold"
        className="
          size-4 text-muted-foreground/50 transition-transform duration-200
          ease-out
          group-hover/card:translate-x-0.5
          group-hover/card:text-muted-foreground
        "
      />
    </Card>
  );

  if (!onClick) {
    return content;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className="
        w-full rounded-2xl text-left
        focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2
        focus-visible:ring-offset-background focus-visible:outline-none
      "
    >
      {content}
    </button>
  );
};
